/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import { Stack, Text } from '@bottlebooks/gatsby-design-system';
import React from 'react';
import { jsx } from 'theme-ui';
import BaseBrandRegion from '@bottlebooks/gatsby-theme-event/src/components/Brand/BrandRegion';
// @ts-ignore
import varietiesIcon from '@bottlebooks/gatsby-theme-event/src/assets/varieties.svg';

export * from '@bottlebooks/gatsby-theme-event/src/components/Brand/BrandRegion';

/**
 *
 * @param {object} props
 * @param {object} props.brand
 * @param {React.ReactNode} [props.children]
 */
export default function BrandRegion({ brand, children, ...rest }) {
  return (
    <Stack spacing={1}>
      <BaseBrandRegion brand={brand} {...rest} />
      {brand.region && (
        <Text variant="smallest" {...rest}>
          <VarietiesIcon sx={{ marginRight: 0.5 }} />{' '}
          <span>{brand.region}</span>
        </Text>
      )}
    </Stack>
  );
}

function VarietiesIcon({ size = 16, ...rest }) {
  return (
    <img
      src={varietiesIcon}
      width={size}
      height={size}
      alt=""
      sx={{ verticalAlign: 'top' }}
      {...rest}
    />
  );
}
